import { RoleState, RoleResponseProps } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getRole, createRole, removeRole, updateRole, showRole } from './roleService';

export const initialState: RoleState = {
    data: {} as RoleResponseProps,
    status: "loading",
    error: {}
}

export const RoleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getRole.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getRole.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getRole.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
            .addCase(createRole.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(createRole.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(createRole.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
            .addCase(removeRole.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(removeRole.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(removeRole.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
            .addCase(updateRole.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(updateRole.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(updateRole.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const RoleReducer = RoleSlice.reducer